import cx from 'classnames'
import { Instrument } from '~/common.interface'
import { getInstrumentCategory, INSTRUMENT_DISPLAY_NAMES } from '~/utils/instrument'
import cs from './instrument_category.scss'

interface InstrumentCategoryProps {
  className?: string
  instrument: Instrument
}

const InstrumentCategory = ({ className, instrument }: InstrumentCategoryProps) => {
  return (
    <div className={cx(className, cs.instrumentCategory)}>
      {getInstrumentCategory(instrument) && (
        <>{getInstrumentCategory(instrument)} &middot;&nbsp;</>
      )}
      {INSTRUMENT_DISPLAY_NAMES[instrument.instrumentType]}
    </div>
  )
}

export default InstrumentCategory
